/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlarmData } from './alarmData';


export interface MachineAlarmResponse { 
    data?: Array<AlarmData>;
    totalItems?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

